import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@et/auth';

@Component({
  selector: 'et-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogoutModalComponent {
  private authService = inject(AuthService);

  /**
   * Logs out user
   * @returns None
   * @memberof LogoutModalComponent
   */
  onLogout() {
    this.authService.logout();
  }
}
